import { userActions } from "../../actionTypes";

const initialState = {
	token: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.GET_FACEBOOK_TOKEN_FETCHING: {
			return { ...state, fetching: true };
		}

		case userActions.GET_FACEBOOK_TOKEN_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				token: action.payload,
			};
		}

		case userActions.GET_FACEBOOK_TOKEN_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
